<template>
  <v-container id="page-voucher-list">
    <div class="page-title">{{ $route.name }}</div>

    <v-row>
      <v-col>
        <div style="width: 250px; display: inline-block;">
          <v-text-field
            v-model="searchKeyword"
            label="바우처 명 검색"
            prepend-icon="search"
            @keyup="onSearch"
          ></v-text-field>
        </div>
      </v-col>
      <v-col class="d-flex justify-end">
        <c-btn
          color="blue"
          class="ml-1"
          outlined
          iconName="add"
          @click="addVoucherDialog = true"
          >바우처 등록</c-btn
        >
      </v-col>
    </v-row>

    <c-table
      :headers="tableHeader"
      itemKey="id"
      :items="voucherList"
      :page="pagination.page"
      :itemsPerPage="pagination.size"
      :totalElements="totalElements"
      @update:tableOptions="updateOption"
    >
      <template #voucherType="{item}">
        {{ item.voucherType }}
      </template>
      <template #created="{item}">
        {{ $func.dateToString(item.created) }}
      </template>
      <template #organization="{item}">
        {{ item.organization }}
      </template>
      <template #action="{ item }">
        <c-btn icon iconName="edit" @click="onEditInfo(item)" />
        <c-btn icon iconName="delete" @click="onDeleteVoucher(item)" />
      </template>
    </c-table>

    <voucher-c-u-dialog
      :open.sync="addVoucherDialog"
      :voucherFormData="voucherFormData"
      @reqAddVoucher="reqAddVoucher"
      @reqUpdateVoucher="reqUpdateVoucher"
    />
  </v-container>
</template>
<script>
import VoucherCUDialog from "./VoucherCUDialog";

export default {
  components: {
    VoucherCUDialog,
  },
  data: () => ({
    tableHeader: [
      {
        text: "바우처 명",
        value: "name",
        align: "center",
        sortable: true,
      },
      {
        text: "바우처 유형",
        value: "voucherType",
        align: "center",
        sortable: true,
      },
      {
        text: "등록일",
        value: "created",
        align: "center",
        sortable: true,
      },
      {
        text: "발급기관",
        value: "organization",
        align: "center",
        sortable: true,
      },
      {
        text: "",
        value: "action",
        align: "center",
        sortable: false,
      },
    ],

    addVoucherDialog: false,
    voucherFormData: null,
    voucherList: [],
    searchKeyword: "",
    pagination: {
      page: 1,
      size: 10,
      sort: "",
    },
    totalElements: 0,
  }),
  watch: {
    addVoucherDialog(value) {
      if (!value) this.voucherFormData = null;
    },
  },
  methods: {
    async reqAddVoucher(data) {
      try {
        const res = await this.$api.addVoucher(data);
        this.addVoucherDialog = false;
        this.reqVoucherList();
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqAddVoucher" });
      }
    },
    async reqUpdateVoucher(data) {
      try {
        const res = await this.$api.updateVoucher(data);
        this.addVoucherDialog = false;
        this.reqVoucherList();
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqUpdateVoucher" });
      }
    },
    async reqVoucherList() {
      try {
        const res = await this.$api.getVoucherList({
          ...this.pagination,
          searchKeyword: this.searchKeyword,
        });
        this.voucherList = res.data.content.map((item) => {
          item.voucherType = item.voucherType.configName;
          return item;
        });
        this.totalElements = res.data.totalElements;
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqVoucherList" });
      }
    },
    onEditInfo(data) {
      this.voucherFormData = {
        id: data.id,
        name: data.name,
        organization: data.organization,
        registerType: data.registerType,
        type: data.voucherType,
        general: data.general,
        infants: data.infants,
        mother: data.mother,
      };
      this.addVoucherDialog = true;
    },
    onDeleteVoucher(voucher) {
      this.$store.commit("alert", {
        open: true,
        persistent: true,
        msg:
          "바우처를 삭제하시겠습니까?\n삭제된 바우처는 재발급이 불가능합니다.",
        confirm: true,
        callBack: () => {
          this.reqDeleteVoucher(voucher);
        },
      });
    },
    async reqDeleteVoucher(voucher) {
      try {
        const res = await this.$api.deleteVoucher(voucher.id);
        this.$store.commit("snackbar", {
          msg: "바우처가 삭제되었습니다.",
          color: "blue",
        });
        this.reqVoucherList();
      } catch (err) {
        this.$store.commit("snackbar", { err, where: "reqDeleteVoucher" });
      }
    },
    onSearch(event) {
      if (event.key === "Enter") {
        this.pagination.page = 1;
        this.reqVoucherList();
      } else {
        return;
      }
    },
    updateOption(option) {
      this.pagination.page = option.page;
      this.pagination.size = option.itemsPerPage;
      if (option.sortBy.length > 0 && option.sortDesc.length > 0) {
        this.pagination.sort = `${option.sortBy[0]},${
          option.sortDesc[0] ? "asc" : "desc"
        }`;
      }
      this.reqVoucherList();
    },
  },
  activated() {
    this.reqVoucherList();
  },
};
</script>

<style></style>
